import { AssignActionType } from '@/api/apis/resources';

export const getDisabledState = (assignActionType: AssignActionType) => {
  const detachDisabled = assignActionType === AssignActionType.Detach;
  const attachDisabled = assignActionType === AssignActionType.LockedAssign;

  return { detachDisabled, attachDisabled };
};

export const getVariantByActionType = (actionType: AssignActionType, isSelected?: boolean, isLogistics?: boolean) => {
  const buttonActionType = isSelected ? AssignActionType.Detach : actionType;
  switch (buttonActionType) {
    case AssignActionType.Assign:
    case AssignActionType.LockedAssign:
      return 'solid';
    case AssignActionType.Detach:
      return isLogistics && !isSelected ? 'solid' : 'outline';
    default:
      return 'outline';
  }
};

export const nonLogisticsDetachWarning = 'Resource is used in logistics and should be managed from there.';
